module.exports = __webpack_public_path__ + "img/ThreeDogs.17c7c1a0.jpg";